import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Voice } from '../data/testimonials';
type TestimonialsProps = {
  voices: Voice[];
  eyebrow?: string;
  title: string;
  subtitle?: string;
  background?: 'white' | 'cream';
};

/**
 * Citas reales de coaches de softball (foros públicos), con su fuente, y
 * dónde lo resuelve el pack. No son reseñas del producto.
 */
export function Testimonials({
  voices,
  eyebrow = 'In coaches’ own words',
  title,
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-ice';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-288" data-mp="2x0jqkt72kbhm">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-289" data-mp="2x2w5exhj65qg">
        <div className="text-center" data-id="element-290" data-mp="2s3097kf2rilg">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-291" data-mp="2s42yxp0nvezs">
            {eyebrow}
          </p>
          <h2 className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-4xl sm:text-5xl" data-id="element-292" data-mp="q9tyfiabiuig">
            {title}
          </h2>
          {subtitle ? <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-293" data-mp="h8az7g8j0vsa">
              {subtitle}
            </p> : null}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-294" data-mp="78tup250gnxw">
          {voices.map(item => <figure key={item.quote} className="flex flex-col rounded-2xl border border-ice-dark bg-white p-5 shadow-card" data-id="element-295" data-mp="c7mx9zireuja">
              <QuoteIcon className="h-6 w-6 text-clay" aria-hidden="true" data-id="element-296" data-mp="14v9bs2tizjkx" />
              <blockquote className="mt-3 text-base font-medium italic leading-snug text-ink" data-id="element-297" data-mp="q5la30hfmiwo">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-3 text-xs text-ink-muted" data-id="element-298" data-mp="v3d2dvlzo71e">
                {item.source}
              </figcaption>
              {item.answer ? <div className="mt-auto pt-4" data-id="element-299" data-mp="1nmses9njuxmy">
                  <div className="rounded-xl border-l-4 border-gold bg-navy px-3.5 py-3" data-id="element-300" data-mp="1xi0npbdbfxz6">
                    <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-301" data-mp="1xfmw5chuh3wd">
                      In the pack
                    </span>
                    <span className="mt-1 block text-[13px] leading-snug text-white/90" data-id="element-302" data-mp="1ofzv4rt1203u">
                      {item.answer}
                    </span>
                  </div>
                </div> : null}
            </figure>)}
        </div>
      </div>
    </section>;
}